// const _USER = {
//   first_name: '',
//   last_name: '',
//   email: '',
//   password: '',
//   confirm_password: '',
// };
// export const INITIAL_USER = {
//   ..._USER,
// };

// export const INTIAL_INPUT_ERROR = {
//   ..._USER,
// };



const _USER = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    confirm_password: '',
    emergency_contact: '',
    is_tc_accepted: true,
  };
  
  export const INITIAL_USER = { ..._USER };
  
  // export const INITIAL_INPUT_ERROR = {
  //   first_name: false,
  //   last_name: false,
  //   email: false,
  //   password: false,
  //   confirm_password: false,
  //   emergency_contact: false, // Initialize validation errors for each field
  //   is_tc_accepted: false, // Add any other fields as needed
  // };
  
  export const INITIAL_INPUT_ERROR = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    confirm_password: '',
    emergency_contact: '',
    is_tc_accepted: '',
  };
  
  